// extracted by mini-css-extract-plugin
export default {"topBand":"TopBand_topBand__tazxC","scrollingText":"TopBand_scrollingText__bSw83","scroll":"TopBand_scroll__qOwDx"};